import React from 'react'
import styles from './catSection.module.css'
import { useNavigate } from 'react-router-dom'

const CatSection = () => {
     const navigate = useNavigate()
     return (
          <div className={styles.catContainer}>
               <div className={styles.catCol} onClick={() => navigate('/bomManage')} style={{ cursor: 'pointer' }}>
                    <div >
                         {/* <img src='/assets/catImg.png' /> */}
                         <img src='/assets/bom.png' className={styles.image} />
                    </div>
                    <span>BOM Management</span>
                    <p>Upload your entire BOM in seconds and get real-time quotations. </p>
               </div>
               <div className={styles.catCol} onClick={() => navigate('/scheduleCart')} style={{ cursor: 'pointer' }}>
                    <div>
                         <img src='/assets/schedule.png' className={styles.image} />
                    </div>
                    <span>Scheduling</span>
                    <p>Plan your purchases, reserve stocks  and adjust delivery timelines.</p>
               </div>
               <div className={styles.catCol} onClick={() => navigate('/exInventoryBuyItem')} style={{ cursor: 'pointer' }}>
                    <div>
                         <img src='/assets/excess.png' className={styles.image} />
                    </div>
                    <span>Excess Inventory</span>
                    <p>Easily list and liquidate unused stock through a shared, anonymous marketplace. </p>
               </div>
               <div className={styles.catCol} onClick={() => navigate('/crossRefer')} style={{ cursor: 'pointer' }}>
                    <div>
                         <img src='/assets/crossreference.png' className={styles.image} />
                    </div>
                    <span>Cross Reference</span>
                    <p>Find exact or compatible alternatives for any part number in just a few clicks. </p>
               </div>
               <div className={styles.catCol} onClick={() => navigate('/wizardUpload')} style={{ cursor: 'pointer' }}>
                    <div>
                         <img src='/assets/wizard.png' className={styles.image} />
                    </div>
                    <span>Wizard</span>
                    <p>Have an urgent requirement? The Wizard tool sends it directly to relevant suppliers instantly. </p>
               </div>
          </div>
     )
}

export default CatSection